import { Grid } from "antd";
import { Breakpoint } from "antd/lib/_util/responsiveObserve";

const { useBreakpoint } = Grid;

export function useBreakpointValue<T>(
  valueOptions: Partial<Record<"base" | Breakpoint, T | undefined>>,
): T | undefined {
  const screens = useBreakpoint();

  const { base, xs, sm, md, lg, xl, xxl } = valueOptions;

  return (
    (screens.xxl && xxl) ||
    (screens.xl && xl) ||
    (screens.lg && lg) ||
    (screens.md && md) ||
    (screens.sm && sm) ||
    (screens.xs && xs) ||
    base
  );
}
